// src/redux/slices/settingSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// Thunk: get setting data
// export const getSettingData = createAsyncThunk(
//   "setting/getSettingData",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await agent.get(API.GET_SETTING);
//       return response.data.data; // adjust based on your API response
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || "Failed to load settings");
//     }
//   }
// );

// Thunk: send contact us form
export const sendContactUs = createAsyncThunk(
  "contactUs/sendContactUs",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await agent.post(API.CONTACT_US_PAGE, formData);
      return response.data?.message;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to send message");
    }
  }
);

const contactUsSlice = createSlice({
  name: "contactUs",
  initialState: {
    loading: false,
    error: null,
    successMessage: null,
  },
  reducers: {
    clearMessage(state) {
      state.successMessage = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendContactUs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendContactUs.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload;
      })
      .addCase(sendContactUs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { clearMessage } = contactUsSlice.actions;

export default contactUsSlice.reducer;
